import { memo, createElement } from '@max/max';
import View from '@hfe/max-view';
import Sensor from '@max/mbc-sensor';
import Text from '@hfe/max-text';
import Button from '@hfe/max-button';
import Image from '@hfe/max-image';
import { BID_MAP } from '@/const';
import './index.scss';
function BountyTask({ bountyTaskConfig, onShareRedNote, onRedNoteAudit, lxReport }) {
    const { bountyTaskText = '小红书发文 赢大额券', bountySubTitle = '分享你的心愿 发布笔记后记得审核上传哦～', bountyNoteImage = 'https://p0.meituan.net/ingee/01acc70a1479e1c2d8d565488366c90213064.png', bountyUploadImage = 'https://p0.meituan.net/ingee/45c3df2c8b5e84ab38d5811acaf288b414960.png' } = bountyTaskConfig || {};
    return <Sensor className="bounty-task" once onAppear={() => lxReport === null || lxReport === void 0 ? void 0 : lxReport(BID_MAP.RED_NOTE_TASK_MV)}>
      <View className="bounty-task-container">
        <View className="bounty-task-content">
          <View className="bounty-task-title-wrap">
            <Image source={{
        uri: 'https://p0.meituan.net/ingee/a25059a0f383afa568fb5d13be8ae0d82427.png'
    }} className="bounty-task-text-icon"/>
            <Text className="bounty-task-text">
              {bountyTaskText}
            </Text>
          </View>
          <Text className="bounty-subtitle">{bountySubTitle}</Text>
        </View>

        <View className="bounty-task-buttons">
          <Sensor once onAppear={() => lxReport === null || lxReport === void 0 ? void 0 : lxReport(BID_MAP.RED_NOTE_SHARE_MV)}>
            <Button className="bounty-task-button-wrapper" onPress={onShareRedNote}>
              <Image source={{
        uri: bountyNoteImage
    }} className="bounty-task-button-image"/>
            </Button>
          </Sensor>
          <Sensor once onAppear={() => lxReport === null || lxReport === void 0 ? void 0 : lxReport(BID_MAP.RED_NOTE_AUDIT_MV)}>
            <Button className="bounty-task-button-wrapper" onPress={onRedNoteAudit} style={{
        marginLeft: '24rpx'
    }}>
              <Image source={{
        uri: bountyUploadImage
    }} className="bounty-task-button-image"/>
            </Button>
          </Sensor>
        </View>
      </View>
    </Sensor>;
}
export default memo(BountyTask);
